module.exports = __webpack_public_path__ + "img/sb2.570c8399.png";